import { SVGProps, Ref, forwardRef } from 'react';

export const DocumentOutlinedSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.4 3.733v24.534h19.2V12c0-3.867-.676-5.681-1.63-6.636-.955-.955-2.77-1.63-6.637-1.63zM4 30.667h24V12c0-8-2.667-10.667-10.667-10.667H4zm18-16.8H10v-2.4h12zm-12 6.666h12v-2.4H10z"
                fill="currentColor"
            />
        </g>
    </svg>
));
DocumentOutlinedSize32Glyph.displayName = 'DocumentOutlinedSize32Glyph';
